import useApi from "./useApi";
import { useMemo } from "react";

const useYearlyEarnings = () => {
  const { get } = useApi();
  const query = get("/earnings-yearly-comparison");

  const currentYear = new Date().getFullYear();

  const dataWithAllMonths = useMemo(() => {
    if (!query.data?.data) return [];

    return Array.from({ length: 12 }, (_, i) => {
      const monthNumber = i + 1;

      const found = query.data.data.find(
        (item) => Number(item.month) === monthNumber
      );

      return {
        month: monthNumber, // keep as number
        current_year: found ? Number(found.current_year) : 0,
        previous_year: found ? Number(found.previous_year) : 0,
      };
    });
  }, [query.data]);


  return { ...query, data: { data: dataWithAllMonths }, currentYear, previousYear: currentYear - 1 };
};

export default useYearlyEarnings;
